module.exports = __webpack_public_path__ + "img/assistantAccount-crm-warp2-img6.183cf0f6.png";